import IncTextField from 'components/forms/fields/inc-text-field/inc-text-field.component';
import { useTranslation } from 'react-i18next';
import { useMapsAddress } from '../../address-form.hooks';

const CityField = ({ name, ...rest }) => {
  const { t } = useTranslation();
  useMapsAddress(name, 'city');

  return (
    <IncTextField
      name={name}
      label={t('forms.fields.city.label')}
      data-testid="CityField"
      {...rest}
    />
  );
};
export default CityField;
